import { useMutation } from 'react-query'

import { addTicket } from '../../endpoints/tickets'

export const useAddTicket = () => {
    return useMutation(async (payload: FormData) => await addTicket(payload))
}
